import NextImage from '../NextImage';
import Link from 'next/link';
import { NavWrapper, NavLi } from './style';
import SubMenu from './SubMenu';
import { useRouter } from 'next/router';

const RenderLinkWithIcon = ({ menu }) => {
  return (
    <div className="icon-login">
      {menu.icon ? (
        <NextImage className="icon" src={menu.icon} alt={menu.label} />
      ) : null}
      <a
        className={menu.icon ? 'icon-label' : 'no-icon-label'}
        href={menu.path}
      >
        {menu.label}
      </a>
    </div>
  );
}; 

const ScrollSpyMenu = ({
  className,
  menuItems,
  locale,
  drawerClose,
  ...props
}) => {
  const router = useRouter();
  const activeTabs = (path) => {
    const currentPath = router.pathname;
    if (currentPath.startsWith('/use-case')) {
      return path === '/use-case' || currentPath.startsWith(path);
    }
    if (currentPath.startsWith('/blog')) {
      return path === '../../blog' || currentPath.startsWith(path);
    }
    if (currentPath.startsWith('/pricing')) {
      return path === '../../pricing?tab=TEAM' || currentPath.startsWith(path);
    }
    if (
      currentPath.startsWith('/ai-agent') ||
      currentPath.startsWith('/ai-hub') ||
      currentPath.startsWith('/security') ||
      currentPath.startsWith('/company') ||
      currentPath.startsWith('/mobile-app') 
    ) {
      return path === '/solutions';
    }
    return currentPath === path;
  };
  return (
    <NavWrapper>
      {menuItems.map((menu, index) => (
        <NavLi key={`menu-item-${index}`} active={activeTabs(menu.path)}>
          {menu.staticLink ? (
            <RenderLinkWithIcon menu={menu} />
          ) : (
            <>
              {(menu?.subMenu || []).length > 0 ? (
                <SubMenu
                  label={menu?.intl[locale]}
                  item={menu?.subMenu}
                  locale={locale}
                />
              ) : (
                <Link href={menu.path} passHref>
                  {menu?.intl[locale]}
                </Link>
              )}
            </>
          )}
        </NavLi>
      ))}
    </NavWrapper>
  );
};

export default ScrollSpyMenu;
